import { RoomPlayer } from "@uno/protocol";
import { create } from "zustand";
import useStoreRoomSession from "./useStoreRoomSession";

type StateStoreRoomPlayer = {
    roomPlayer: RoomPlayer | null,
}

type StoreRoomPlayerActions = {
    setRoomPlayer: (roomPlayer: RoomPlayer | null) => void,
    reset: () => void,
}

const useStoreRoomPlayer = create<StateStoreRoomPlayer & StoreRoomPlayerActions>((set) => ({
    roomPlayer: null,

    setRoomPlayer: (roomPlayer) => set(() => ({ roomPlayer })),
    reset: () => set(() => ({ roomPlayer: null })),
}));

useStoreRoomSession.subscribe(
    (state) => state.roomId,
    () => {
        useStoreRoomPlayer.getState().reset();
    }
);

export default useStoreRoomPlayer;